export default __webpack_public_path__ + "static/media/printing.e038bb4c.png";